import React, { Component } from 'react';
import {Dropdown} from 'react-bootstrap'

import './period-dropdown.css';

export function lastDay () {
  const end = new Date()
  const start = new Date(end)
  start.setDate(end.getDate() - 1);
  return [start, end]
}
export function lastWeek() {
  const end = new Date()
  const start = new Date(end)
  start.setDate(end.getDate() - 7);
  return [start, end]
}
export function lastMonth() {
  const end = new Date()
  const start = new Date(end)
  start?.setMonth(end.getMonth() - 1);
  return [start, end]
}

export default class PeriodDropDown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentValue: this.props.dropDown ?? 0
    }
    this.options = [
      "Last day", "Last week", "Last month", "Prior Month", "Custom"
    ];
    this.values = [
      lastDay, lastWeek, lastMonth, this.priorMonth, this.custom
    ]
    this.clickedPeriod = this.clickedPeriod.bind(this);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.dropDown !== this.props.dropDown)
      this.setState({currentValue: this.props.dropDown})
  }
  priorMonth() {
    let end = new Date()
    end.setDate(0);  // last day, prev month
    end.setHours(23,59,59,0)
    let start = new Date(end)
    start.setDate(1);
    start.setHours(0,0,0,0)
    return [start, end];
  }
  custom () {
    return []
  }
  clickedPeriod(item) {//onUpdate is DatePanel.interval()
    this.setState({currentValue: item})
    const newDates = this.values[item]()
    this.props?.onUpdate(newDates[0], newDates[1], item, this.options[item])
  }

  render() {
    return(
     <Dropdown className="panel-dropdown">
        <Dropdown.Toggle className="panel-toggle">{this.options[this.state.currentValue]}
        </Dropdown.Toggle>
       <Dropdown.Menu>
         {this.options.map((item, index) => 
           <Dropdown.Item key={index} onClick={()=>this.clickedPeriod(index)} 
             active={index===this.state.currentValue}>
             {this.options[index]} 
           </Dropdown.Item>
         )}
       </Dropdown.Menu>
     </Dropdown>
    )
  }
} 
